module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAAEFBAMAAABEF/uvAAAAD1BMVEUBlI4Pk4wdk400m5RfwLzu31HXAAAAjUlEQVR42u3MMQ3AMBAEwYcQBYEVBJEMwfw5uT0DeMnFbLfN1Jqd/fV+nY0a1dtzLp/P5/P5fD6fn/H5fD6fz+fz+Rmfz+fz+Xw+n5/x+Xw+n8/n8/kZn8/n8/l8Pp+f8fl8Pp/P5/P5GZ/P5/P5fD6fn/H5fD6fz+fz+Rmfz+fz+Xw+n5/x+Xw+/w5/Ayj8L8d5ommdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/images/books/blank.png
// module id = 1393
// module chunks = 1